<template>
  <div class="aloneEstateInformation">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>安全生产检查
      </span>
      <span class="other more" @click="equAdministrationAccount()">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="safeProduction-main ub ub-ac">
      <!-- <div class="body1 font1">
      <span>安全生产检查</span>
      <span>|</span>
      <span>专项检查</span>
      </div>-->
      <div class="safe-body" v-for="(item, index) in items" :key="index">
        <div
          class="safe-item title ft16 col-33"
          :title="item.Title"
          @click="linkTo(item.MatterKeyId,item.PaperType)"
        >主题：{{item.Title}}</div>
        <div
          class="safe-item ft14 col-66"
        >时间：{{item.StartTime|formatDate('yyyy-MM-dd')}}至{{item.EndTime|formatDate('yyyy-MM-dd')}}</div>
        <div class="safe-item ft14 col-66">类型：{{item.PaperType==1?'常规检查':'专项检查'}}</div>
        <div class="safe-item ft14 col-66">
          得分：
          <span class="fontRed">{{item.PaperType==1?item.Grade:'-'}}</span>
        </div>
      </div>
      <div class="tx-c mar-t" v-if="items.length<1">
        <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
        <br />暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import { SecurityCheckAMatterController } from '@/service/SecurityCheckAMatterController/SecurityCheckAMatterController';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      data: {},
      cellData: {},
      Position: 'running',
      items: []
    };
  },
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
    this.securityCheckAMatterController = new SecurityCheckAMatterController();
  },
  mounted() {
    this.homePageControllerSvr.GetAreaInfo(this.token, 0, 1).then(res => {
      this.cellData = res._Items[0];
    });
    this.getdata();
  },
  methods: {
    enterEaArea(code) {
      this.$router.push({
        path: '/propertyAreaInfo',
        query: { OrgCode: code }
      });
    },
    linkTo(key, type) {
      this.$router.push({
        path: 'SafeProductionList',
        query: {
          keyId: key,
          Safetype: type
        }
      });
    },
    getdata() {
      this.securityCheckAMatterController
        .getCardListByRealtyComUser(this.token, 0, 0, 0, 2)
        .then(res => {
          this.items = res;
        });
    },
    equAdministrationAccount() {
      //this.$router.push('/equAdministrationAccount');
      this.$router.push('/SafeProductionCheckList');
    },
    enterequAdministration() {
      this.$router.push('/equAdministration');
    },
    enterRepair() {
      this.$router.push('/repairMge');
    },
    enterPatrol() {
      this.$router.push('/patrolRecordList');
    },
    enterMaintenance() {
      this.$router.push('/maintenanceMge');
    }
  }
};
</script>
<style lang="scss" scoped>
@import './css/common.scss';
.aloneEstateInformation {
  background-color: #fff;
  .fontRed {
    color: red;
    font-size: 14px;
    font-weight: 600;
  }
  .index-header {
    .more {
      color: #797979;
    }
  }
  .iconStyle {
    font-size: 100px;
    padding-bottom: 20px;
  }
  .safeProduction-main {
    height: 260px;
    background-color: #fff;
    display: flex;
    overflow: hidden;
    //数字样式
    //红色
    .mar-t {
      width: 100%;
    }
    .safe-body {
      padding: 0 20px 20px 20px;
      height: 80%;
      width: 50%;
      &:nth-child(2n) {
        border-left: 1px solid #ddd;
      }
      .title {
        font-weight: 600;
        cursor: pointer;
        &:hover {
          color: #1890ff;
          transition: all 0.3s;
        }
        font-size: 14px;
        border-left: 4px solid #0f77f2;
        padding-left: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .safe-item {
        line-height: 1.5;
        margin: 10px 0;
      }
    }
    .fontRed {
      color: #ff4546;
    }
    //蓝色
    .fontBlue {
      color: #0f77f2;
    }
    .margintop {
      margin-top: 20px;
    }
  }
}
</style>